/* import __COLOCATED_TEMPLATE__ from './adi-toggle.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class AdiToggle extends Component {
  @action onToggleChange() {
    if (this.args.handleToggleChange) this.args.handleToggleChange(!this.args.toggled);
  }
}
